import React, { useEffect, useRef } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import SafeIcon from '../common/SafeIcon';

function MabelBlogEmbed() {
  const embedRef = useRef(null);

  useEffect(() => {
    if (!embedRef.current) return undefined;

    embedRef.current.innerHTML = '';

    const script = document.createElement('script');
    script.src = 'https://embed.mylocalbusiness.io/widgets/production/latest/widgets.js';
    script.async = true;
    script.setAttribute('data-my-widget', 'blog');
    script.setAttribute('data-business-id', '68ed1d30810a9565f1164840');
    script.setAttribute('data-location-id', '68ed1d6b810a9565f1164842');

    embedRef.current.appendChild(script);

    return () => {
      if (embedRef.current) {
        embedRef.current.innerHTML = '';
      }
    };
  }, []);

  return <div ref={embedRef} className="min-h-[320px]" />;
}

export default function Blog() {
  return (
    <div className="min-h-screen flex flex-col bg-[#F7F8F7] text-[#101F1F] overflow-x-hidden">
      <Navbar />

      <main className="flex-grow pt-20">
        {/* SECTION 1 — Blog Widget Embed */}
        <section className="py-20 md:py-24 bg-[#F7F8F7]">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center max-w-3xl mx-auto mb-10">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#409FA1]/30 bg-white shadow-sm mb-6">
                <SafeIcon name="BookOpen" className="w-4 h-4 text-[#409FA1]" />
                <span className="text-xs font-michroma uppercase tracking-widest text-[#244A49] font-bold">
                  Latest Articles
                </span>
              </div>

              <h1 className="text-3xl md:text-5xl font-bold tracking-tight text-[#101F1F] mb-4 leading-tight">
                RepUpgrade Blog
              </h1>

              <p className="text-lg text-[#101F1F]/70 leading-relaxed max-w-2xl mx-auto font-medium">
                Useful local business articles shaped by real customer language.
              </p>
            </div>

            <div className="rounded-[2rem] border border-gray-200 bg-white p-4 md:p-8 shadow-xl shadow-[#244A49]/5 overflow-hidden min-h-[400px] flex items-center justify-center">
              <div className="w-full">
                <MabelBlogEmbed />
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 2 — Mabel Writes Explanation */}
        <section className="py-20 bg-white border-t border-gray-100">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#F7F8F7] border border-gray-100 mb-6">
                <SafeIcon name="Sparkles" className="w-4 h-4 text-[#F2C230]" />
                <span className="text-xs font-michroma uppercase tracking-widest text-[#244A49] font-bold">
                  Mabel Writes for RepUpgrade
                </span>
              </div>

              <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[#101F1F] mb-6 leading-tight">
                Mabel Writes for RepUpgrade
              </h2>
            </div>

            <div className="space-y-6 text-[#101F1F]/80 leading-relaxed">
              <p className="text-lg">
                Mabel turns reputation signals into useful articles. She looks at customer reviews, sentiment patterns, business strengths, service details, and local search opportunities — then helps shape content that sounds grounded, specific, and helpful.
              </p>

              <p className="text-lg">
                For RepUpgrade, that means the blog is built from the language customers already use when they explain why they trust a business.
              </p>

              <div className="rounded-2xl border border-gray-200 bg-[#F7F8F7] p-8 my-10">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-white border border-gray-100 flex items-center justify-center shrink-0 shadow-sm">
                    <SafeIcon name="Quote" className="w-6 h-6 text-[#409FA1]" />
                  </div>
                  <div>
                    <p className="text-lg font-medium text-[#101F1F] leading-relaxed">
                      Good reviews tell the market what matters. Mabel helps turn that signal into something people can actually read, understand, and use.
                    </p>
                  </div>
                </div>
              </div>

              <div className="rounded-2xl border border-[#409FA1]/20 bg-[#409FA1]/5 p-6">
                <p className="text-base text-[#101F1F]/70 leading-relaxed">
                  <span className="font-semibold text-[#244A49]">Note:</span> The same review-powered writing system can support local businesses that want clearer articles, stronger trust pages, and content shaped by real customer language.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}